import { Expose } from 'class-transformer'
import type { PersonResource as Model } from '@/services/api/client'

import type { CamelCaseKeys } from '@/types/utility'

export type SerializedPersonSearchResponse = Model

export default class PersonSearchResponse implements CamelCaseKeys<SerializedPersonSearchResponse> {
    id: Model['id']

    created: Model['created']

    archived?: Model['archived']

    address?: Model['address']

    age?: Model['age']

    birthdate?: Model['birthdate']

    email?: Model['email']

    family?: Model['family']

    family_role?: Model['family_role']

    metadata?: Model['metadata']

    phone?: Model['phone']

    name?: Model['name']

    @Expose({ name: 'profile_photo' })
    profilePhoto?: Model['profile_photo']

    tags?: Model['tags']

    constructor(values: PersonSearchResponse) {
        Object.assign(this, values)
    }
}
